<template>
  <div class="chat_details_wrapper crud_form_wrapper pa-5">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.show_message_details") }}</h4>
    </div>

    <div class="single_step_form_content_wrapper">
      <div class="mb-5 card-style" elevation="1">
        <v-card-title>{{ $t("PLACEHOLDERS.client_info") }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="4"
              ><strong>{{ $t("PLACEHOLDERS.name") }}:</strong>
              {{ chat.user?.name }}</v-col
            >
            <v-col cols="12" sm="4"
              ><strong>{{ $t("PLACEHOLDERS.phone") }}:</strong>
              {{ chat.user?.mobile }}</v-col
            >
          </v-row>
        </v-card-text>
      </div>

      <div class="mb-5 card-style" elevation="1">
        <v-card-title>{{ $t("PLACEHOLDERS.last_message") }}</v-card-title>
        <v-card-text>
          <p>
            <strong>{{ $t("PLACEHOLDERS.date") }}:</strong>
            {{ chat.last_message?.created_at }}
          </p>
          <p>
            <strong>{{ $t("PLACEHOLDERS.contents") }}:</strong>
            {{ chat.last_message?.message_text }}
          </p>
        </v-card-text>
      </div>

      <div class="mb-5 message-container card-style" elevation="1">
        <v-card-title>{{ $t("PLACEHOLDERS.all_messages") }}</v-card-title>
        <v-card-text>
          <div class="chat-wrapper">
            <div
              v-for="msg in chat?.messages"
              :key="msg.id"
              class="chat-message-row w-100 d-flex mb-4"
              :class="
                msg.from_type === 'provider' ? 'message-left' : 'message-right'
              "
            >
              <div
                class="chat-message d-flex"
                :class="
                  msg.from_type === 'provider' ? 'justify-start' : 'justify-end'
                "
              >
                <v-avatar
                  size="40"
                  class="mr-3"
                  v-if="msg.from_type === 'provider'"
                >
                  <img
                    v-if="
                      msg.from_type === 'provider'
                        ? chat.user.avatar
                        : chat.admin.avatar
                    "
                    :src="
                      msg.from_type === 'provider'
                        ? chat.user.avatar
                        : chat.admin.avatar
                    "
                    alt="sender image"
                    class="image"
                  />
                  <v-icon v-else>mdi-account</v-icon>
                </v-avatar>

                <div class="message-content">
                  <p class="d-block mb-1">{{ msg.created_at }}</p>
                  <div class="bubble px-3 py-2">
                    <div class="fw-bold mb-1">
                      {{
                        msg.from_type === "provider"
                          ? chat.user.name
                          : chat.admin.name
                      }}
                    </div>
                    <div>{{ msg.message_text }}</div>
                  </div>
                </div>
                <!-- 
                <v-avatar
                  size="40"
                  class="ml-3"
                  v-if="msg.sender_type !== 'provider'"
                >
                  <img
                    v-if="
                      msg.from_type === 'provider'
                        ? chat.user.avatar
                        : chat.admin.avatar
                    "
                    :src="
                      msg.from_type === 'provider'
                        ? chat.user.avatar
                        : chat.admin.avatar
                    "
                  />
                  <v-icon v-else>mdi-account</v-icon>
                </v-avatar> -->
              </div>
            </div>
          </div>
        </v-card-text>
      </div>

      <form @submit.prevent="sendReply">
        <div class="card-style" elevation="1">
          <v-card-text>
            <base-input
              type="text"
              col="12"
              v-model.trim="replyText"
              :placeholder="$t('PLACEHOLDERS.enter_reply')"
              outlined
            />

            <div class="btn_wrapper text-end">
              <base-button
                class="mt-2"
                styleType="primary_btn"
                :btnText="$t('PLACEHOLDERS.send')"
                type="submit"
                :isLoading="sending"
                :disabled="sending || replyText.length == 0"
              />
            </div>
          </v-card-text>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowChat",
  
  data() {
    return {
      chat: {
        user: {

},
        last_message: {},
        messages: [],
      },
      replyText: "",
      sending: false,
      snackbar: false,
    };
  },
  methods: {
    async fetchChat() {
      try {
        const res = await this.$axios.post(`provider-chats/show-chat`, {
          user_id: this.$route.params.id,
          type: "provider_admin",
        });
        this.chat = res.data.data;
        console.log(res);
      } catch (err) {
        console.error("Error loading chat:", err);
      }
    },
    async sendReply() {
      if (!this.replyText.trim()) return;

      this.sending = true;

      try {
        await this.$axios.post(`/provider-chats/${this.chat.id}/send-message`, {
          message: this.replyText,
          to_type: "provider",
          to_id: this.$route.params.id,
        });
        this.$message.success(this.$t("MESSAGES.replied_successfully"));

        await this.fetchChat();

        this.replyText = "";
        this.snackbar = true;
      } catch (err) {
        console.error("Reply failed", err);
      } finally {
        this.sending = false;
      }
    },
  },
  created() {
    this.fetchChat();
  },
};
</script>

<style scoped>
.chat_details_wrapper {
  max-width: 100%;
  margin: auto;
}

.chat-wrapper {
  max-width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
}

.chat-message-row {
  width: 100%;
}

.message-left {
  justify-content: flex-start;
}

.message-right {
  justify-content: flex-end;
}

.chat-message {
  max-width: 75%;
  gap: 8px !important;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.message-content {
  max-width: 300px;
  padding: 8px;
  border-radius: 5px !important;
  width: 260px;
  box-shadow: 2px 2px 3px 1px #33313130;
  margin-block-start: 4px;
  background-color: var(--theme_main_bg_clr);
}

.bubble {
  border-radius: 25px !important;
  padding: 6px;
}

.message-left .bubble {
  background-color: var(--theme_main_bg_clr);
}

.message-right .bubble {
  background-color: var(--theme_main_bg_clr);
}

.card-style {
  background-color: var(--theme_second_bg_clr);
  box-shadow: 2px 2px 3px 1px #33313130;
  padding: 4px;
  border-radius: 4px;
}

.image {
  flex-shrink: 0;
}

.message-container {
  overflow-y: scroll;
  height: 300px;
  padding: 3px;
}
</style>
